import React, { useEffect } from "react";
import { VideoEmbed } from "./VideoEmbed";
import { HOME_OVERVIEW_VIDEO, HOME_OVERVIEW_VIDEO_SCHEMA } from "@shared/homeOverviewVideo.mjs";

export function HomeOverviewVideoSchema() {
  useEffect(() => {
    const id = "structura-home-overview-video-schema";
    const script = document.head.querySelector<HTMLScriptElement>(`#${id}`) || document.createElement("script");
    script.id = id;
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(HOME_OVERVIEW_VIDEO_SCHEMA);
    if (!script.parentNode) document.head.appendChild(script);
    return () => script.remove();
  }, []);

  // Build-time HEAD injection supplies this schema to crawlers without JS.
  return null;
}

export function HomeOverviewVideoSection() {
  return (
    <section id="system-overview" aria-labelledby="system-overview-heading" className="bg-[#020617] py-16 lg:py-24">
      <div className="container">
        <div className="mx-auto mb-12 max-w-4xl text-center">
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.42em] text-[#35E3E3]">
            THE SYSTEM IN 80 SECONDS
          </p>
          <h2 id="system-overview-heading" className="text-3xl font-black tracking-[-0.045em] text-white md:text-5xl">
            One chart. Three people. Three different questions.
          </h2>
        </div>
        <VideoEmbed
          videoId={HOME_OVERVIEW_VIDEO.videoId}
          title={HOME_OVERVIEW_VIDEO.title}
          playLabel={HOME_OVERVIEW_VIDEO.playLabel}
          posterFallbackUrl={HOME_OVERVIEW_VIDEO.fallbackThumbnailUrl}
          bordered
          centerPlayButton
        />
        <div className="mt-6 text-center">
          <a
            href={HOME_OVERVIEW_VIDEO.playlistUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-semibold text-slate-400 transition hover:text-[#35E3E3] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#35E3E3]"
          >
            How each layer reads a chart →
          </a>
        </div>
      </div>
    </section>
  );
}
